import type { PermissionRef } from '../../api/types.ts';

export interface PermissionGroup {
  resource: string;
  permissions: PermissionRef[];
}

/** Returns the first validation problem, or null when the name is submittable. */
export function validateRoleName(name: string): string | null {
  const trimmed = name.trim();
  if (trimmed === '') return 'Enter a role name.';
  if (trimmed.length > 64) return 'Role name must be 64 characters or fewer.';
  return null;
}

/** Groups the full permission catalog by resource prefix, sorted for a
 *  stable render order (config, owners, reports, roles, shops, users). */
export function groupPermissionsByResource(permissions: PermissionRef[]): PermissionGroup[] {
  const byResource = new Map<string, PermissionRef[]>();
  for (const perm of permissions) {
    const resource = perm.code.split(':')[0] ?? perm.code;
    const group = byResource.get(resource) ?? [];
    group.push(perm);
    byResource.set(resource, group);
  }
  return Array.from(byResource.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([resource, perms]) => ({ resource, permissions: perms }));
}

// Resources whose label isn't just the capitalised key: "reports" is the
// Shop Reports page's permission group.
const LABEL_OVERRIDES: Record<string, string> = { reports: 'Shop Reports' };

export function resourceLabel(resource: string): string {
  return LABEL_OVERRIDES[resource] ?? resource.charAt(0).toUpperCase() + resource.slice(1);
}
